import styled from 'styled-components';
import { mobile480, tablet768 } from '@nubank/nuds-web/styles/breakpoints';

export const FormBlock = styled.div`
  height: 53rem;
  margin-top: -1rem;

  ${mobile480`
    height: 49rem;
  `}

  ${tablet768`
    width: 26rem;
    height: 52rem;
    margin-top: 0;
  `}
`;

FormBlock.displayName = 'FormBlock';
